import React, {useState, useEffect, useRef, forwardRef, useImperativeHandle} from "react"
import {Button, Divider, Tooltip} from "antd"
import allSend from "../../image/chat/allSend.png"
import sendSingle from "../../image/chat/sendSingle.png"
import wxappLink from "../../image/messageList/wxappLink.png";
import txt from "../../image/file/txt.png";
import ppt from "../../image/file/ppt.png";
import word from "../../image/file/word.png";
import excel from "../../image/file/excel.png";
import pdf from "../../image/file/pdf.png";
import zip from "../../image/file/zip.png";
import unknownFile from "../../image/messageList/unknownFile.png";
import audioPause from "../../iconfont/audio/audioPause.png";
import videoHao from "../../image/messageList/videoHao.png";
import SendPopUp from "./sendPopUp";
import IconDownArrow from "../../iconfont/downArrow/downArrow";
import IconUpArrow from "../../iconfont/upArrow/upArrow";
import newAllSend from "../../image/chat/newAllSend.png"
import newSendSingle from "../../image/chat/newSendSingle.png"
import copyToInputField from "../../image/chat/copyToInputField.png"
import IconNewUpArrow from "../../iconfont/newUpArrow/newUpArrow";
import PubSub from 'pubsub-js'

const SingleContent = forwardRef((props, ref) => {
    const [item, setItem] = useState({})
    const [wordMessage, setWordMessage] = useState({})
    const [list, setList] = useState([])//素材内容列表
    const [aFold, setAFold] = useState(false)//素材展开收起的开关
    const [chatData, setChatData] = useState({})//左侧联系人的数据消息
    const sendPopUpRef = useRef(null)
    useEffect(() => {
        setChatData(props.chatData)
    }, [props.chatData])
    useEffect(() => {
        setWordMessage(props.title)
    }, [props.title])

    //保存传过来的数据
    useEffect(() => {
        setList(props.data)
    }, [props.data])

    //保存传过来的展开收起的按钮状态
    useEffect(() => {
        setAFold(props.aFoldFlag)
    }, [props.aFoldFlag])

    //点击展开收起按钮事件
    function aFoldClick(aFold) {
        setAFold(!aFold)
    }

    //文件图标展示
    function fileImg(fileName) {
        if (fileName) {
            if (fileName.indexOf('txt') != -1) {
                return txt
            } else if (fileName.indexOf('ppt') != -1) {
                return ppt
            } else if (fileName.indexOf('doc') != -1) {
                return word
            } else if (fileName.indexOf('xlsx') != -1 || fileName.indexOf('xls') != -1 || fileName.indexOf('csv') != -1) {
                return excel
            } else if (fileName.indexOf('pdf') != -1) {
                return pdf
            } else if (fileName.indexOf('zip') != -1 || fileName.indexOf('rar') != -1 || fileName.indexOf('7z') != -1 || fileName.indexOf(' gzip') != -1 || fileName.indexOf(' tar.gz') != -1) {
                return zip
            } else if (fileName.indexOf('video') != -1) {
                return 'video'
            } else if (fileName.indexOf('image') != -1) {
                return 'image'
            } else {
                return unknownFile
            }
        }
    }

    //点击单条发送
    function sendSingleClick(item, chatId) {
        sendPopUpRef.current.openSendPopUp(chatData, JSON.parse(JSON.stringify(item)), chatId)
    }

    // useImperativeHandle(ref, () => ({
    //     getBack:getBack
    // }))
    // function getBack(obj) {
    //     sendPopUpRef.current && sendPopUpRef.current.getBack(obj)
    // }
    function clickCopyCharacter(content) {
        PubSub.publish('COPY_TO_INPUT_FIELD', content);
    }


    return (
        <div className={'single_word'}>
            <div className={'words_title'}>
                <Tooltip title={'发送整组'}>
                    <img src={newAllSend} onClick={sendSingleClick.bind(this, list, wordMessage.chatId)}/>
                </Tooltip>
                <div onClick={aFoldClick.bind(this, aFold)}>
                    <span className={'art_title_words'}>
                    <span>{wordMessage.chatName}</span>（{list.length}）</span>
                    <span className={'a_flod'}>{aFold == false ? <IconNewUpArrow/> : <IconDownArrow/>}</span>
                </div>
            </div>
            <div className={'new_add_line'}>
                <div className={aFold == false ? 'wordUnfold hidden_word' : 'wordPackUp hidden_word'}>
                    {
                        list && list.map((item, index) => {
                            return <div className={'single_word_first'} key={index}>
                                <Tooltip title={'发送单条'}>
                                    <img src={newSendSingle} style={{width: '14px', height: '14px'}}
                                         onClick={sendSingleClick.bind(this, [item], wordMessage.chatId)}/>
                                </Tooltip>
                                {
                                    item.type == 1 ? <div className={'word_characters'}>
                                            <span className={'input_field zk-text-warp'}>{item.content.character}</span>
                                            <Tooltip title={'复制到输入框'}>
                                                <img src={copyToInputField}
                                                     onClick={clickCopyCharacter.bind(this, item.content.character)}/>
                                            </Tooltip>
                                        </div> :
                                        item.type == 2 ?
                                            <div className={'word_picture'}><img src={item.content.picture}/></div> :
                                            item.type == 3 ? <div className={'new_word_link'}>
                                                    <img src={item.content.linkCover}/>
                                                    <div className={'word_link_desc'}>
                                                        <span
                                                            className={'new_link_title'}>{item.content.linkHeadline}</span>
                                                        <span
                                                            className={'word_link_stract'}>{item.content.linkAbstract}</span>
                                                    </div>
                                                </div> :
                                                item.type == 4 ? <div className={'word_mi_ni_program'}
                                                                      style={{flexDirection: 'column'}}>
                                                        <div className={'word_mi_ni_program_head'}>
                                                            <img src={item.content.thumburl}/>
                                                            <div>{item.content.title}</div>
                                                        </div>
                                                        {item.content.desc ? <span
                                                            className={'word_mi_ni_program_desc'}>{item.content.desc}</span> : ''}
                                                        <img src={item.content.coverimgurl} style={{width: '100%'}}/>
                                                        <div className={'wxInfo-line'}></div>
                                                        <div className={'wxapp-bottom'}>
                                                            <img src={wxappLink}/>
                                                            <div className={'im-wxcard'}>{'小程序'}</div>
                                                        </div>
                                                    </div> :
                                                    item.type == 5 ? <div className={'word_file'}>
                                                            <img src={fileImg(item.content.uploadFilesName)}/>
                                                            <div>
                                                                <span>{item.content.uploadFilesName}</span>
                                                                {item.content.dataSize ? <span
                                                                    className={'word_file_size'}>{Math.floor(item.content.dataSize / 1000)}K</span> : ''}
                                                            </div>
                                                        </div> :
                                                        item.type == 6 ? <div className={'word_video'}>
                                                                <video src={item.content.uploadVideoUrl}/>
                                                            </div> :
                                                            item.type == 7 ? <div className={'word_audio'}>
                                                                    <img src={audioPause}
                                                                         style={{height: '15px'}}
                                                                         className={'audioImg'}/>
                                                                </div> :
                                                                item.type == 8 ? <div className={'word_video_overlap'}
                                                                                      style={{flexDirection: 'column'}}>
                                                                    <div className={'word_video_overlap_bg'}>
                                                                        <img src={item.content.thumb_url}/>
                                                                    </div>
                                                                    <div className={'im-videoHao-mid'}>
                                                                        <img src={item.content.head_img_url}/>
                                                                        <span>{item.content.username}</span>
                                                                    </div>
                                                                    <div
                                                                        className={'video_number_description_telephony_library'}>{item.content.channel_name}</div>
                                                                    <div className={'im-videoHao-divider'}>
                                                                        <Divider/>
                                                                    </div>
                                                                    <div className={'im-videoHao-bottom'}>
                                                                        <img src={videoHao}/>
                                                                        <span>{'视频号'}</span>
                                                                    </div>
                                                                </div> : ''
                                }

                            </div>
                        })
                    }
                </div>
            </div>
            {/*<div className={'all_send'} style={{display: 'flex'}}>*/}
            {/*    <img src={allSend} onClick={sendSingleClick.bind(this, list, wordMessage.chatId)}/>*/}
            {/*    <div style={{width: 'calc(100% - 26px)', display: 'flex', justifyContent: 'flex-end'}}>*/}
            {/*        （共{list.length}条话术）*/}
            {/*        {list.length > 1 ?*/}
            {/*            <a style={{display: 'flex', alignItems: 'center'}}*/}
            {/*               onClick={aFoldClick.bind(this, aFold)}>{aFold == false ? <>展开&nbsp;*/}
            {/*                <IconDownArrow/></> : <>收起&nbsp;<IconUpArrow/></>}</a>*/}
            {/*            : ''}*/}
            {/*    </div>*/}
            {/*</div>*/}
            <SendPopUp ref={sendPopUpRef}/>
        </div>
    )
})
export default SingleContent